import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchReferralCatalog = () => {
  const response = useQuery({
    queryKey: ['referralCatalog'],
    queryFn: () => api.referral.fetchCatalog(),
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить реферальный список',
      type: 'error',
    })
  }

  return response
}
